import React, { useState, useEffect } from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import {
  useApproveConcepts,
  useReturnConcepts,
  useUpdateGestorConceptsStatus,
} from '../../../../share';
import {
  useConceptsSolicitud,
} from '../../../../utils/validators/entry-request/entryGestorUpdateValidator';
import TechnicalConceptDetailView from '../views/TechnicalConceptDetailView';
import { useDownloadFilesTechnicalConcept, useDownloadPdfTecnhicalConcept, useFetchTechnicalConceptById } from '../../../../hooks/technicalConcept/technicalConcept';
import { ModalType } from '../../../../utils';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import { useLocation } from 'react-router-dom';


interface TechnicalConceptDetailContainerProps {
  isOpen: boolean;
  OnClose: () => void;
  technicalId?: string;
  onViewDetail: (id: string) => void;
  isViewApproved?: boolean;
  setFilter?: any;
  fromApprvals?: any;
  refetch?: () => void;
}

const TechnicalConceptDetailContainer: React.FC<
  TechnicalConceptDetailContainerProps
> = ({
  isOpen,
  OnClose,
  technicalId,
  isViewApproved,
  setFilter,
  fromApprvals = false,
  refetch,
}) => {
    const [footerLeft, setFooterLeft] = useState<React.ReactNode>(null);
    const { mutateAsync: updateGestorStatus } = useUpdateGestorConceptsStatus();
    const { mutateAsync: returnPetitionConcept } = useReturnConcepts();
    const { mutateAsync: approvePetitionConcept } = useApproveConcepts();
    const { mutateAsync: downloadFiles } = useDownloadFilesTechnicalConcept();
    const { mutateAsync: generatePdf } = useDownloadPdfTecnhicalConcept();
    const { showToast } = useCustomToast();
    const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false);
    const location = useLocation();
    const [modalState, setModalState] = useState<{
      type: ModalType;
      technicalId?: string;
    }>({
      type: null,
      technicalId: undefined,
    });

    const isTechnicalRequestsView = location.pathname.includes('/technicalconcept');

    useEffect(() => {
      if (technicalId) {
        setModalState({ type: 'detail', technicalId });
      }
    }, [technicalId]);

    const { data: detailData, isPending: isLoading, refetch: refetchId } =
      useFetchTechnicalConceptById(technicalId, fromApprvals);

    const onSaveSolicitud = async (values: any) => {
      const token = localStorage.getItem('auth');
      const tokenToJs = token ? JSON.parse(token).authorization.token : null;

      const body = {
        status_id: values.status_id || '68',
        reason: values.reason || 'Sin registro',
        items: values.items,
      };

      try {
        await updateGestorStatus({
          body,
          token: tokenToJs,
          id: Number(detailData?.id),
        });
        showToast('success', 'Ítems actualizados correctamente');
        if (fromApprvals) {
          setFilter({});
        }
        refetch && refetch();
        onReset();
        refetchId();
      } catch (error) {
        console.error('Error al actualizar los ítems del gestor:', error);
      }
    };

    const onReturnPetition = async (values: any) => {
      const token = localStorage.getItem('auth');
      const tokenToJs = token ? JSON.parse(token).authorization.token : null;

      const body = {
        reason: values.reason,
      };

      try {
        await returnPetitionConcept({
          body,
          token: tokenToJs,
          id: Number(detailData?.id),
        });
        showToast('success', 'Ítems actualizados correctamente');
        OnClose();
        refetch && refetch();
        refetchId();
      } catch (error) {
        console.error('Error al actualizar los ítems del gestor:', error);
      }
    };

    const onApprovePetition = async (values: any) => {
      const token = localStorage.getItem('auth');
      const tokenToJs = token ? JSON.parse(token).authorization.token : null;

      const body = {
        reason: values.reason,
        item_data: values.items.map((item: any) => ({
          status_id: values.status_id,
          technical_concept_typification_id: values.technical_concept_typification_id,
          observations: item.observations || null,
        })),
      };

      try {
        await approvePetitionConcept({
          body,
          token: tokenToJs,
          id: Number(detailData?.id),
        });

        showToast('success', 'Ítems actualizados correctamente');
        if (fromApprvals) {
          setFilter({});
        }
        refetch && refetch();
        refetchId();
        OnClose();
      } catch (error) {
        console.error('Error al actualizar los ítems del gestor:', error);
      }
    };

    const formikSolicitud = useConceptsSolicitud({ onSubmit: onSaveSolicitud });
    const formikReturnPetition = useConceptsSolicitud({
      onSubmit: onReturnPetition,
    });
    const formikApprovePetition = useConceptsSolicitud({
      onSubmit: onApprovePetition,
    });
    const closeModalSaveChanges = () => {
      setiIsOpenSaveChanges(false);

    };
    const onReset = () => {
      formikSolicitud.resetForm();
      setiIsOpenSaveChanges(false);
      setTimeout(() => {
        OnClose();
      }, 300)
    };

    const submit = () => {
      if (
        formikSolicitud.values.status_id === '68' &&
        formikSolicitud.values.items.length === 0
      ) {
        showToast('error', 'Debe gestionar antes el activo.');
        return;
      }
      formikSolicitud.handleSubmit();
    };

    const validateAndOpenModal = async () => {

      if (formikSolicitud.isValid) {
        setiIsOpenSaveChanges(true);
      }
    };

    const handleDownloadFiles = () => {
      if (!detailData?.id || !detailData?.ticket) {
        showToast('error', 'No se puede descargar: falta el ID o el ticket');
        return;
      }

      downloadFiles({ conceptId: detailData.id, ticket: detailData.ticket });
    };

    return (
      <CustomModal
        title={`Detalle solicitud de concepto técnico - ${detailData?.ticket || 'N/A'}`}
        open={isOpen}
        onCancel={onReset}
        labelCancel='Finalizar'
        width="95vw"
        isLoading={isLoading}
        footerLeft={footerLeft}
        onSave={validateAndOpenModal}
        labelSubmit={
          detailData?.status_id === '67' && !isTechnicalRequestsView
            ? 'Guardar'
            : ''
        }
      >
        <TechnicalConceptDetailView
          detailData={detailData}
          setFooterLeft={setFooterLeft}
          onDocuments={handleDownloadFiles}
          receiptPdf={generatePdf}
          formikSolicitud={formikSolicitud}
          formikReturnPetition={formikReturnPetition}
          formikApprovePetition={formikApprovePetition}
          isViewApproved={isViewApproved}
          refetchId={refetchId}
          refetch={refetch}
        />

        <ModalSaveChanges
          title="Guardar cambios"
          textOne="¿Está seguro de crear esta solicitud de concepto técnico?"
          textTwo="Una vez creado no podrá realizar cambios."
          open={isOpenSaveChanges}
          width={900}
          isLoadingSave={false}
          onClose={() => {
            closeModalSaveChanges();
          }}
          labelSubmit="Aceptar"
          onSave={() => {
            submit();
          }}
        />
      </CustomModal>
    );
  };

export default TechnicalConceptDetailContainer;
